import { render, staticRenderFns } from "./PickupsSearch.vue?vue&type=template&id=c4a18b3a&scoped=true&"
import script from "./PickupsSearch.vue?vue&type=script&lang=ts&"
export * from "./PickupsSearch.vue?vue&type=script&lang=ts&"
import style0 from "./PickupsSearch.vue?vue&type=style&index=0&id=c4a18b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a18b3a",
  null
  
)

export default component.exports